<!-- 留学教育 -->
<template>
  <div class="home">
    <div class="content">
      <div class="header">
        <div class="header_left">
          <div class="Breadcrumb">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>新闻列表</el-breadcrumb-item>
              <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <h1>兰乔帕迪斯｜独栋</h1>
        </div>
        <div class="QRcode">
          <img src="@/assets/QRcode.png" alt="" />
          <span>手机看新闻</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="less">
.content {
  margin: 0 auto;
  width: 100%;
  max-width: 75rem;
}
</style>
